// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3qfny","row":"Node_row__1a0x9","label":"Node_label___en2v","footer":"Node_footer__gACPS"};